import styled from "styled-components";
import { Button } from "../../../components/util";

export const LastButton = styled(Button).attrs((props: any) => ({}))`
  margin-top: 25px;
`;
